// extracted by mini-css-extract-plugin
export default {"jobs":"Jobs_jobs__P00D2","jobs_header":"Jobs_jobs_header__AtBvY","label":"Jobs_label__ZsqYH","count":"Jobs_count__elfv7","jobs_list":"Jobs_jobs_list__TvOZd"};